export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const titleCase = (str: string): string => {
  const splitStr = str.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
};

export const kebabCaseToCamelCase = (kebabCase: string) => {
  const [first, ...rest] = kebabCase.split("-");
  return first + rest.map(capitalizeFirstLetter).join("");
};

export const kebabCaseToSnakeCase = (kebabCase: string): string => {
  return kebabCase.split("-").join("_");
};
